import { useEffect, useMemo } from "react";

import classes from "./Report.module.css";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

function MismatchedInvoice({ mismatchedInvoiceData, onTabClick, loading }) {
  useEffect(() => {
    onTabClick(); // Call the onTabClick function when the component mounts
  }, [onTabClick]);

  const rows = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan={11} className={classes.loader}>
            Loading...
          </td>
        </tr>
      );
    }
    const missMatchedData = mismatchedInvoiceData?.record?.missMatched || [];

    if (!missMatchedData.length) {
      return (
        <tr>
          <td colSpan={17} className={classes.noData}>
            No Data Found!
          </td>
        </tr>
      );
    }

    return missMatchedData.map((invoice, index) => (
      <tr key={index}>
        <td style={{ color: "black" }}>{invoice.GSTIN}</td>
        <td style={{ color: "black" }}>{invoice.Vendor_Name}</td>
        <td style={{ color: "black" }}>{invoice.DOC_NUMBER}</td>
        <td style={{ color: "black" }}>{invoice.DOC_DATE}</td>
        <td style={{ color: "black" }}>{invoice.DOC_TYPE}</td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.CGST_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.SGST_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.IGST_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Cess_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Books).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.CGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.SGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.IGST_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Cess_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Books_GSTR6A).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.TaxValue_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount_Diff).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>{invoice.Remarks}</td>
      </tr>
    ));
  }, [loading, mismatchedInvoiceData?.record?.missMatched]);

  return (
    <>
      <BoxWrapper
        searchInputPlaceholder="Search..."
        boxTitle="Reconciliation Status: Mis-Matched Invoice(s)"
      >
        <div className={classes.ResponsiveTable}>
          <table className={classes.missingInAccountTableCss}>
            <thead>
              <tr>
                <th rowSpan={2}>GSTIN</th>
                <th rowSpan={2} align="right">
                  CUSTOMER NAME
                </th>
                <th rowSpan={2} align="right">
                  DOC NUMBER
                </th>
                <th rowSpan={2} align="right">
                  DATE
                </th>
                <th rowSpan={2} align="right">
                  TYPE
                </th>
                <th
                  style={{ background: "#ffcc66" }}
                  colSpan={6}
                  align="center"
                >
                  As per Books
                </th>
                <th
                  style={{ background: "#c6ffb3" }}
                  colSpan={6}
                  align="center"
                >
                  As per GSTR6A
                </th>
                <th
                  style={{ background: "#85c0d4" }}
                  colSpan={3}
                  align="center"
                >
                  DIFFERENCE
                </th>
                <th style={{ background: "RED" }} rowSpan={2} align="right">
                  REMARKS
                </th>
              </tr>
              <tr>
                <th style={{ background: "#ffcc66" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  TOTAL AMOUNT
                </th>

                <th style={{ background: "#c6ffb3" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#c6ffb3" }} align="right">
                  TOTAL AMOUNT
                </th>
                <th style={{ background: "#85c0d4" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#85c0d4" }} align="right">
                  TAX
                </th>
                <th style={{ background: "#85c0d4" }} align="right">
                  TOTAL AMOUNT
                </th>
              </tr>
            </thead>

            <tbody>{rows}</tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}

export default MismatchedInvoice;
